import React from "react";
import { GetTable } from "../../common/components/DataTable";
import { ImpiantoReport } from "../../generated";
import PlantsReplacementsReportStore from "../PlantsReplacementsReportStore";
import ReportsActions from "../ReportsActions";
import { attach } from "../../common/componentExtensions";
import { Link, RouteComponentProps, useHistory } from "react-router-dom";
import DatesHelper from "../../common/datesHelper";
import { Loading } from "../../common/components/loading";
import { ComuneData } from "../../comuni/components/ComuneData";
import { links } from "../../routes";

const Table = GetTable<ImpiantoReport>();
interface Props extends RouteComponentProps<{ minYears: string }> {
    minYears: number;
    items: ImpiantoReport[]
}

const PlantsReplacementsPage = (props: Props) => {
    const history = useHistory();
    React.useEffect(() => {
        const stored = PlantsReplacementsReportStore.get(props.minYears.toString());
        if (!Array.isArray(stored)) {
            ReportsActions.getPlantForReplacementsCampaign(props.minYears);
        }
    }, [props.minYears]);

    const onChange = (e: React.ChangeEvent<HTMLElement>) => {
        const search = "?" + new URLSearchParams({ minYears: (e.target as any).value }).toString();
        history.push({
            pathname: history.location.pathname,
            search
        })
    }

    if (props.items == null)
        return <Loading />

    return <div className="card">
        <div className="card-header bg-theme d-flex">
            <div className="flex-fill"><h3 className="text-white mb-0">Report installazioni</h3></div>
        </div>
        <div className="card-body">
            <div className="mb-3">
                <strong className="me-2">Visualizza impianti più vecchi di</strong>
                <input
                    style={{ width: 80 }}
                    className="form-control d-print-none"
                    type="number"
                    min={2}
                    max={50}
                    value={props.minYears}
                    onChange={onChange}
                />
                <strong className="ms-2">(anni)</strong>
            </div>
            <Table data={props.items}
                keySelector={x => x.idImpianto.toString()}
                filterables={[
                    x => x.marca,
                    x => x.modello,
                    x => x.nome,
                    x => x.cognome,
                    x => x.responsabile
                ]}>
                <Table.Column
                    header="Cliente"
                    template={x => {
                        const cognomeNome = `${x.cognome} ${x.nome}`;
                        return <Link to={links.customerShow(x.idCliente)} target="_blank">
                            <div>{cognomeNome}</div>
                            {x.responsabile && x.responsabile.toLowerCase() != cognomeNome.toLowerCase() && <div>{`${x.responsabile}`}</div>}
                        </Link>
                    }}
                />
                <Table.Column
                    header="Apparecchio"
                    template={x => <Link to={links.impiantoEdit(x.idImpianto)} target="_blank">
                        <div style={{ whiteSpace: "nowrap" }}>
                            {`${x.marca} - ${x.modello}`}
                        </div>
                        <div>{`${x.potenzaFocolare && x.potenzaFocolare > 0 ? x.potenzaFocolare : "N.C."} KW`}</div>
                    </Link>}
                    groupBy={x => x.marca || ""}
                    orderBy={x => x.marca || "" + x.modello || ""}
                />
                <Table.Column
                    header="Indirizzo"
                    template={x => x.indirizzo}
                />
                <Table.Column
                    header="Città"
                    template={x => x.codFisComune && <ComuneData
                        codFisComune={x.codFisComune}
                        selector={c => <div>{c?.nomeComune ?? ""} {c?.provincia ?? ""}</div>} />}
                />
                <Table.Column
                    header="Data installazione"
                    template={x => <span
                        style={{ fontSize: "1rem" }}
                        className="badge bg-secondary text-white">
                        {
                            x.dataInstallazione
                                ? DatesHelper.getReadableDateString(x.dataInstallazione)
                                : "non disponibile"
                        }
                    </span>}
                    groupable={false}
                />
                <Table.Column
                    header="Anni"
                    template={x => <span
                        style={{ fontSize: "1rem" }}
                        className="badge bg-danger"
                    >
                        {
                            x.dataInstallazione
                                ? new Date().getFullYear() - x.dataInstallazione.getFullYear()
                                : "non disponibile"
                        }
                    </span>}
                />
            </Table>
        </div>
    </div>
}

export default attach(PlantsReplacementsPage, PlantsReplacementsReportStore, (store, props) => {
    const params = new URLSearchParams(props.location.search);
    const minYearsString = params.get("minYears") || "";
    const parsed = parseInt(minYearsString);
    const minYears = !isNaN(parsed) ? parsed : 20;
    const stored = store.get(minYears.toString());
    return {
        minYears,
        items: Array.isArray(stored) ? stored : [],
    }

})